import { SupabaseClient } from '@supabase/supabase-js';
import { LogoBackgroundDto } from 'modules/core/domain/interfaces/supabase/organizer-logo-background/response-dto';

export default class OrganizerLogoBacking {
  constructor(private supabase: SupabaseClient) {}

  async get({ tournamentId }: { tournamentId: number }): Promise<LogoBackgroundDto | null> {
    const { data, error } = await this.supabase
      .from('organizer_logo_backing')
      .select()
      .eq('tournamentId', tournamentId)
      .single<LogoBackgroundDto>();

    if (error) {
      console.error(error);
      return null;
    }

    return data;
  }

  async update({ tournamentId, type }: { tournamentId: number; type: number }): Promise<LogoBackgroundDto | null> {
    const { data, error } = await this.supabase
      .from('organizer_logo_backing')
      .upsert({ tournamentId, type }, { onConflict: 'tournamentId' })
      .select()
      .single<LogoBackgroundDto>();

    if (error) {
      console.error(error);
      return null;
    }

    return data;
  }
}
